import React, { useEffect, useState } from "react";
import { useTittleContenidoStore } from "../context/tittleContenidoStore";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../services/firebase";
import BackdropComponent from "../components/CargaComponents/BackdropComponent";
import {
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { formatTimestamp, formatTimestampOtp } from "../constants/Functions";

const DevicesSociosNotifications = () => {
  const { setTittleContenido }: any = useTittleContenidoStore();
  const [devices, setDevices] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 6; // Número de socios por página

  const obtenerDevices = async () => {
    setIsLoading(true);
    try {
      //comprobar si el usuario tiene un token valido activo antes de obtener los dispositivos

      // Obtener los dispositivos
      const deviceSnapshot = await getDocs(
        collection(db, "tokensDevicesGeneral")
      );
      const deviceList = deviceSnapshot.docs.map((doc) => doc.data());
      setDevices(deviceList);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    obtenerDevices();
    setTittleContenido("Dispositivos registrados para Notificaciones");
  }, []);

  // Cambiar la página
  const handlePageChange = (event: any, value: any) => {
    setCurrentPage(value);
  };

  // Filtrar dispositivos por marca o por nombre
  const filteredDevices = devices.filter((device) => {
    console.log(device);
    const idDispositivo = device.deviceId?.toString() || "";
    const nombre = device.nombreDispositivo?.toString() || "";
    const marca = device.marcaDispositivo?.toString() || "";
    const sistemaOperativo = device.sistemaOperativo?.toString() || "";
    const createdAt = device.createdAt?.toString() || "";
    return (
      idDispositivo.toLowerCase().includes(search.toLowerCase()) ||
      nombre.toLowerCase().includes(search.toLowerCase()) ||
      marca.toLowerCase().includes(search.toLowerCase()) ||
      sistemaOperativo.toLowerCase().includes(search.toLowerCase()) ||
      createdAt.toLowerCase().includes(search.toLowerCase())
    );
  });
  // Calcular el número de páginas
  const pageCount = Math.ceil(filteredDevices.length / itemsPerPage);

  // Obtener socios de la página actual
  const displayedDevices = filteredDevices.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  return (
    <div>
      {isLoading && <BackdropComponent enabled={isLoading} />}
      <div className="d-flex justify-content-center h-100 mb-5">
        <TextField
          label="Buscar por DNI, celular, ID dispositivo, nombre dispositivo, marca, sistema operativo o fecha de registro"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-50"
        />
        <br />
        <br />
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
                DNI Socio
              </TableCell>
              <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
                Nro. celular
              </TableCell>
              <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
                ID dispositivo
              </TableCell>
              <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
                Nombre del dispositivo
              </TableCell>
              <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
                Marca
              </TableCell>

              <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
                Sistema operativo
              </TableCell>
              <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
                Token
              </TableCell>
              <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
                FechaRegistro
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedDevices.map((device) => (
              <TableRow key={device.deviceId}>
                <TableCell>{device?.dni}</TableCell>
                <TableCell>{device?.nroCelular}</TableCell>
                <TableCell>{device.deviceId}</TableCell>
                <TableCell>{device?.nombreDispositivo}</TableCell>
                <TableCell>{device?.marcaDispositivo}</TableCell>

                <TableCell>{device?.sistemaOperativo}</TableCell>
                <TableCell>{device?.token}</TableCell>
                <TableCell>{formatTimestampOtp(device?.createdAt)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      {/* Paginación */}
      <Stack spacing={2} alignItems="center" marginY={2}>
        <Pagination
          count={pageCount}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
        />
      </Stack>
    </div>
  );
};

export default DevicesSociosNotifications;
